module.exports = __webpack_public_path__ + "img/img3.e043c0ff.png";